import {
    ADD_LIST,
    ADD_MODAL_CREATE_LIST,
    ADD_ARTICLE_DETAIL,
    ADD_MODAL_RENAME_LIST,
    ADD_MODAL_DELETE_LIST,
} from '../../constants/ListConstants'

export const addList = list => {
    return {
        type: ADD_LIST,
        payload: {
            list
        }
    }
}

export const modalCreateList = modal_createList => {
    return {
        type: ADD_MODAL_CREATE_LIST,
        payload: {
            modal_createList
        }
    }
}

export const addArticle = article => {
    return {
        type: ADD_ARTICLE_DETAIL,
        payload: {
            article
        }
    }
}

export const modalRenameList = modal_renamelist => {
    return {
        type: ADD_MODAL_RENAME_LIST,
        payload: {
            modal_renamelist
        }
    }
}

export const modalDeleteList = modal_deletelist => {
    return {
        type: ADD_MODAL_DELETE_LIST,
        payload: {
            modal_deletelist
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/ListAction.js